import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';

export let closeItemPeek = action('closeItemPeek', () =>
    addDatapointConfig({
        name: 'CloseItemPeek',
    })
);
